import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../UI/Button';
import './TotpVerify.css';

const TotpVerify = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { verifyTotp } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (code.length !== 6 || !/^\d{6}$/.test(code)) {
      setError('Please enter a valid 6-digit code');
      return;
    }

    setLoading(true);
    const result = await verifyTotp(code);
    if (!result.success) {
      setError(result.error || 'Invalid code, please try again');
      setCode('');
    }
    setLoading(false);
  };

  return (
    <div className="totp-container">
      <div className="totp-card">
        <div className="totp-card__header">
          <h2>Two-Factor Authentication</h2>
          <p>Enter the 6-digit code from your authenticator app.</p>
        </div>

        {error && (
          <div className="totp-card__error">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="totp-code" className="form-label">
              Authenticator Code
            </label>
            <input
              id="totp-code"
              type="text"
              inputMode="numeric"
              pattern="\d{6}"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              className="form-input totp-card__code-input"
              placeholder="000000"
              disabled={loading}
              autoComplete="one-time-code"
              autoFocus
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            size="large"
            loading={loading}
            disabled={loading}
            className="totp-card__submit"
          >
            Verify
          </Button>
        </form>
      </div>
    </div>
  );
};

export default TotpVerify;
